var _rect, _rect2, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedCongratulationsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.222,
    y: 6.223,
    width: 99.556,
    height: 99.556,
    rx: 49.778,
    fill: "#6C5AFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 56,
    fill: "#6C5AFC",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.508 68.795c-2.423 0-2.423-3.785 0-3.785h14.385c2.422 0 2.422 3.785 0 3.785H48.508zM52.294 80c-2.423 0-2.423-3.785 0-3.785h6.814c2.422 0 2.422 3.785 0 3.785h-6.814zM44.117 60.316c1.665 1.816-1.212 4.24-2.877 2.27-2.726-3.33-4.24-7.57-4.24-11.961C37 40.328 45.328 32 55.625 32 66.073 32 74.4 40.328 74.4 50.625c0 4.39-1.515 8.63-4.24 11.962-1.666 1.968-4.543-.455-2.877-2.272a15.647 15.647 0 003.331-9.69c0-8.177-6.662-14.84-14.99-14.84-8.177 0-14.84 6.663-14.84 14.84 0 3.634 1.06 6.965 3.332 9.69zM48.508 74.397c-2.423 0-2.423-3.786 0-3.786h14.385c2.422 0 2.422 3.786 0 3.786H48.508z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.842 52.443c-1.666-1.666 1.06-4.24 2.726-2.575l4.845 5.149 8.782-10.297c1.515-1.817 4.392.454 2.877 2.423l-9.993 11.81c-.758.909-2.12 1.06-2.877.152l-6.36-6.662z",
    fill: "#fff"
  })));
}

export default SvgLedCongratulationsIcon;